/**
 * Phase 23 / Plan 23-04 / D-11 — Generic Mollie-Dashboard-URL-Helper.
 *
 * Baut die URL zum Mollie-Dashboard-Eintrag eines Payment-Versuches. Wird in
 * der MolliePaymentSection (Plan 23-05) verwendet, damit Admins via Klick auf
 * den "Im Mollie-Dashboard öffnen"-Button direkt zur Mollie-Web-UI springen.
 *
 * Tenant-agnostisch — Mollie-Login-Routing uebernimmt die Profile-Discrimination
 * automatisch. Falls Tenants spaeter mehrere Mollie-Profile pro Organisation
 * brauchen (Marketplace-Use-Case, deferred), kann die Funktion ohne API-Bruch
 * um einen `profileId`-Parameter erweitert werden.
 *
 * Security (T-23-Dashboard-XSS):
 *   `encodeURIComponent` wird angewendet, auch wenn Mollie-Payment-IDs
 *   alphanumerisch sind ("tr_xxx") — Defense-in-Depth fuer den Fall, dass
 *   irgendwo upstream eine kompromittierte ID durchrutscht.
 */
export function buildMollieDashboardUrl(molliePaymentId: string): string {
    return "https://www.mollie.com/dashboard/payments/" + encodeURIComponent(molliePaymentId);
}
